export default {
  //存储当前登录用户信息
  storeUser(data) {
    window.localStorage.setItem('admin-user', JSON.stringify(data.user))
  },

  fetchUser() {
    let user = window.localStorage.getItem('admin-user')
    return JSON.parse(user)
  },

  clearUser() {
    window.localStorage.removeItem('admin-user')
  },

  //存储token令牌
  storeToken(data) {
    window.localStorage.setItem('admin-token', data.token)
  },

  fetchToken() {
    return window.localStorage.getItem('admin-token')
  },

  clearToken() {
    window.localStorage.removeItem('admin-token')
  },
  //功能菜单项
  storeMenuItems(items) {
    items.forEach(item => {
      item.img = require(`../assets/img/icon_menu_${item.name}.png`);
      item.name = item.name.toLowerCase();
    });
    window.localStorage.setItem('admin-menuItems', JSON.stringify(items))
  },

  // 本地缓存权限列表
  storeSystemMenuItems(system) {
    window.localStorage.setItem('admin-systemMenuItems', system);
  },

  // 本地缓存OSS路径
  storeOssPath(url) {
    window.localStorage.setItem('admin-ossPath', url);
  },

  // 获取本地缓存OSS路径
  fetchOssPath() {
    return window.localStorage.getItem('admin-ossPath');
  },

  // 本地缓存OSS路径
  storeOssConfig(data) {
    window.localStorage.setItem('admin-ossConfig', data);
  },

  // 获取本地缓存OSS路径
  fetchOssConfig() {
    return window.localStorage.getItem('admin-ossConfig');
  },

  // 本地缓存用户信息
  storeUserInfo(url) {
    window.localStorage.setItem('admin-userInfo', JSON.stringify(url));
  },

  // 获取本地缓存用户信息
  fetchUserInfo() {
    return JSON.parse(window.localStorage.getItem('admin-userInfo'));
  },

  // 本地缓存用户类型 20 子帐号 10 管理员
  storeSystemJurisdiction(jurisdiction) {
    window.localStorage.setItem('admin-systemJurisdiction', jurisdiction);
  },

  fetchMenuItems() {
    let data = window.localStorage.getItem('admin-menuItems')
    return JSON.parse(data)
  },

  // 获取权限列表
  fetchSystemItems() {
    return window.localStorage.getItem('admin-systemMenuItems').split(',');
  },

  fetchSystemJurisdiction() {
    return window.localStorage.getItem('admin-systemJurisdiction');
  },

  clearMenuItems() {
    window.localStorage.removeItem('admin-menuItems')
  },

  //存储当前打开的菜单key
  storeMenuKey(currentKey) {
    window.localStorage.setItem('admin-currentKey', currentKey)
  },

  fetchMenuKey() {
    return window.localStorage.getItem('admin-currentKey')
  },

  clearMenuKey() {
    return window.localStorage.removeItem('admin-currentKey')
  },

  //存储汉堡包开关的状态
  storeFoldState(state) {
    window.localStorage.setItem('admin-foldState', state)
  },

  fetchFoldState() {
    let ret = window.localStorage.getItem('admin-foldState') == 'true'
  },

}



// WEBPACK FOOTER //
// ./src/utility/cache.js